import type EnType from '../en-US/response';

export default {
  'response.responseDefinitionWasDeleted':
    'La definición de respuesta fue eliminada, por favor intenta con otra',
  'response.responseIsNotJson': 'El formato de los datos de respuesta no es JSON',
  'response.responseIsNotMsgpack': 'El formato de los datos de respuesta no es Msgpack',
  'response.responseIsNotNoContent': 'Esta respuesta no debería tener un body',
  'response.resultResponseWithDetail': 'devolvió {response}, esperado {responseDefinition}.',
  'response.responseSizeThreshold': 'si el tamaño de datos es mayor a 50MB, la respuesta no se mostrará',
  'response.imageContentType': 'Imagen: {type}',
  'response.fileContentType': 'Archivo: {type}',
  'response.pdfContentType': 'PDF: {type}',
  'response.videoContentType': 'Video: {type}',
  'response.tooManyCharacters': 'Por razones de rendimiento, el contenido de la respuesta no está formateado.',
  'response.saveAsFile': 'Guardar como archivo',
} satisfies typeof EnType;
